import { SkeletonLoader } from '@toggle/design-system';
import React from 'react';

import styles from './NewsThumbnailSkeleton.module.scss';

export const NewsThumbnailSkeleton = () => (
  <div className={styles.root} data-testid="news-thumbnail-skeleton">
    <div className={styles.rowSkeletonWrapper}>
      <SkeletonLoader
        areas={[
          {
            styles: {
              width: '20px',
              height: '20px',
              borderRadius: '50%',
            },
          },
        ]}
      />
      <SkeletonLoader
        areas={[
          {
            styles: {
              width: '114px',
              height: '16px',
              borderRadius: '8px',
            },
          },
        ]}
      />
    </div>
    <SkeletonLoader
      areas={[
        {
          styles: {
            width: '100%',
            height: '24px',
            borderRadius: '8px',
          },
        },
      ]}
    />
  </div>
);
